<template>
  <!-- 表格底部-->
  <tfoot class="table-tfoot">
    <tr class="row">
      <slot></slot>
    </tr>
    <tr class="row" v-show="$route.name !== 'addExpenseRecord'&&$route.name !== 'addLoss'&&$route.name !== 'addTurnPond'&&$route.name !== 'addProofing'&&$route.name !== 'addFeeding'&&$route.name !== 'addPrevention'&&$route.name !== 'addManure'">
      <td>抹零</td>
      <!-- <td :colspan="colspan-1" class="smallChangeAmount">
        <input :value='smallChangeAmountNum' @input="updateSmallChangeAmount" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" type="text" :maxlength="num50" />
      </td> -->
      <td-ex :colspan="colspan-1" type="number" number :bindValue="smallChangeAmount" @changeModel="updateSmallChangeAmount"/>
    </tr>
    <tr class="row">
      <td>备注</td>
      <!-- <td :colspan="colspan-1" class="remark">
        <input :value='remark' @input="updateRemark" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" type="text" :maxlength="num50" />
      </td> -->
       <td-ex :colspan="colspan-1" type="input" :editable="!disabled" :bindValue="remark" @changeModel="updateRemark"/>
    </tr>
    <tr class="addRow">
      <td :colspan="colspan">
        <span :class="{ disabled }" @click="onAddRow">
          <img src="../../../public/img/icon_add_line.png" alt="">
          增行
        </span>
        <span :class="{ disabled }" @click="onDelRow">
           <img src="../../../public/img/icon_del_rows.png" alt="">
          删行</span>
      </td>
    </tr>
  </tfoot>
</template>

<script>
import TdEx from "./TdEx.vue";
export default {
  name: "TfootEx",
  components: { TdEx },
  props: {
    remark: String,
    smallChangeAmount: Number,
    // 禁用增行/删行/备注编辑
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "remark",
    event: "update:remark"
  },
  data() {
    return {
      colspan: 0,
      num50: 50
    };
  },
  mounted() {
    let units = this.$slots.default.filter(f => f.tag);
    this.colspan = units.length;
  },
  methods: {
    onAddRow() {
      if (this.disabled) return;
      this.$emit("addRow");
    },
    onDelRow() {
      if (this.disabled) return;
      this.$emit("delRow");
    },
    updateRemark(e) {
      this.$emit("update:remark", e);
    },
    updateSmallChangeAmount(e) {
      this.$emit("update:smallChangeAmount", e);
    }
  },
  computed: {
    smallChangeAmountNum(value) {
      value = Number(value);
      return isNaN(value) ? 0 : value;
    }
  }
};
</script>


<style lang="stylus" scoped>
.table-tfoot
  tr>td
    text-align center
    height 40px
    line-height 37px
    color: #333;
    font-size: 14px;

  .row
    font-size 14px
    background-color #fff
    // color #ff4848
    font-weight bold

    >td
      text-align center
      border 1px solid #e0e0e0
  .addRow
    td
      text-align left
      height 37px
      line-height 37px
      background-color #fff
      border 1px solid #e0e0e0
      // border-bottom 1px solid #e0e0e0
      >span:first-child
        padding-left 30px;
      >span:last-child
        padding-left 20px
      >span
        display inline-block
        font-weight bold
        font-size 14px
        color #ff4848
        cursor pointer
        position relative
        >img
          position absolute;
          top:12px;
          right:35px;

        &:nth-child(1)
          // margin 0 20px
          color rgba(51, 137, 255, 1);

        &:nth-child(2)
          margin 0 20px
      >span.disabled
        color #c5c5c5
        cursor not-allowed
        >img
          opacity 0.4
</style>
